import DevelopedWithYouTube from "../../components/DevelopedWithYouTube";
import FeatureRow from "./FeatureRow";
import SectionHeader from "./SectionHeader";
import { QuizPreview, StudyPlanPreview, VideoPreview } from "./ProductPreviews";

function StudentSection() {
  return (
    <section data-ga-section="student" className="bg-white pt-20 pb-12">
      <div className="max-w-screen-lg mx-auto px-6 flex flex-col gap-20">
        <SectionHeader
          eyebrow="For students"
          title="A YouTube-based learning experience, without the noise."
          sub="Same videos your kid already loves — curated, organized into goals, and wrapped in quizzes that turn watching into understanding."
        />
        <FeatureRow
          eyebrow="01 · Curated"
          title="No distractions. No junk content."
          body="Learnforest strips out the ads, the autoplay, and the unsuitable content. Your child watches educational videos — nothing else."
          bullets={[
            "Every video filtered for educational value",
            "Recommendations optimized for learning",
            "Block any channel, any time",
          ]}
          preview={<VideoPreview />}
          tint="bg-pastelblue-light"
        />
        <FeatureRow
          eyebrow="02 · Personalized"
          title="Study plans that follow curiosity."
          body="Tell Learnforest what your child wants to learn. The AI builds a 4–6 lesson plan from the best videos on the web, structured around the actual learning goal."
          bullets={[
            "Works for any topic — math to chess to gardening",
            "Adapts as they progress",
            "Each lesson is a handful of curated videos",
          ]}
          preview={<StudyPlanPreview />}
          tint="bg-pastelyellow-light"
          reverse
        />
        <div className="flex flex-col gap-7">
          <FeatureRow
            eyebrow="03 · Active"
            title="Watching becomes understanding."
            body="Every video ends with a 5-question check-in, an AI-written summary of the key ideas, and a chance to ask follow-up questions. No more passive screen time."
            bullets={[
              "AI summary after each video",
              "Interactive quizzes & Q&A",
              "Misses loop back into the plan",
            ]}
            preview={<QuizPreview />}
            tint="bg-pastelgreen-light"
          />
          <div className="flex justify-center">
            <DevelopedWithYouTube
              className="rounded-lg bg-white px-3 py-1"
              imageClassName="h-auto w-[207px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default StudentSection;
